import React, { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Heading } from '../../components/atoms/Heading';
import { ProgressBar } from '../../components/molecules/ProgressBar';
// import { Image } from '../../components/atoms/Image';
import { MainView } from '../../templates/MainView';

import { StickyButtons } from '../../components/molecules/StickyButtons';
import { ButtonGroup } from '../../components/molecules/ButtonGroup';
import { Button } from '../../components/atoms/Button';

import BarrierForm from '../../components/forms/BarrierForm';

function Barrier() {
    let { pathway } = useParams();
    const navigate = useNavigate();
    const [options, setOptions] = useState([]);
    const bcts = useSelector((state) => state.bcts);

    useEffect(() => {
        let newOpt = [];
        Object.keys(bcts[pathway]).map((key) => {
            const bct = bcts[pathway][key];
            newOpt.push({
                label: bct.label,
                value: bct.id,
            });
            return bct.id;
        });
        setOptions(newOpt);
    }, [pathway, bcts]);

    return (
        <MainView>
            <Form
                onSubmit={(values) => navigate(`/pathway-${pathway}/barrier-${values.barrier}`)}
                initialValues={{
                    barrier: '',
                }}>
                {({ handleSubmit, values }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="h-auto w-full">
                            <div className="flex flex-col md:flex-col-reverse">
                                <ProgressBar min={0} current={2} max={3} />
                                <div className="bg-primary-200 p-5 md:bg-transparent">
                                    <Heading h3 classes="text-lg md:text-xl">
                                        Habit Hacker
                                    </Heading>
                                </div>
                            </div>
                            <BarrierForm back={() => navigate(-1)} options={options} />
                            <div className="px-6 pb-12 pt-4">
                                <StickyButtons>
                                    <ButtonGroup
                                        mode="pair"
                                        alwaysRow
                                        buttons={[
                                            <Button
                                                label="Back"
                                                mode="secondary"
                                                onClick={() => navigate(-1)}
                                                type="button"
                                                // isDisabled={isFirstStep}
                                            />,
                                            <Button
                                                label="Continue"
                                                mode="primary"
                                                isSubmit
                                                isDisabled={!values.barrier}
                                            />,
                                        ]}
                                    />
                                </StickyButtons>
                            </div>
                        </div>
                    </form>
                )}
            </Form>
        </MainView>
    );
}

export default Barrier;
